export function validateArray(arr, name = 'array') {
  if (!Array.isArray(arr)) {
    throw new TypeError(`${name} must be an array`);
  }
  if (arr.length === 0) {
    throw new Error(`${name} cannot be empty`);
  }
  return true;
}

export function validate2DArray(arr, name = 'array') {
  validateArray(arr, name);
  if (!arr.every(row => Array.isArray(row))) {
    throw new TypeError(`${name} must be a 2D array`);
  }
  const rowLength = arr[0].length;
  if (!arr.every(row => row.length === rowLength)) {
    throw new Error(`All rows in ${name} must have the same length`);
  }
  return true;
}

export function validateNumericArray(arr, name = 'array') {
  validateArray(arr, name);
  if (!arr.every(val => typeof val === 'number' && !isNaN(val))) {
    throw new TypeError(`All elements in ${name} must be numbers`);
  }
  return true;
}

export function validateNumeric2DArray(arr, name = 'array') {
  validate2DArray(arr, name);
  if (!arr.every(row => row.every(val => typeof val === 'number' && !isNaN(val)))) {
    throw new TypeError(`All elements in ${name} must be numbers`);
  }
  return true;
}

export function validateShapesMatch(X, y, xName = 'X', yName = 'y') {
  validateArray(X, xName);
  validateArray(y, yName);
  if (X.length !== y.length) {
    throw new Error(`${xName} and ${yName} must have the same number of samples. Got ${X.length} and ${y.length}`);
  }
  return true;
}

export function validatePositiveInteger(value, name = 'value') {
  if (!Number.isInteger(value) || value <= 0) {
    throw new Error(`${name} must be a positive integer, got ${value}`);
  }
  return true;
}

export function validateNumber(value, name = 'value') {
  if (typeof value !== 'number' || isNaN(value)) {
    throw new TypeError(`${name} must be a number, got ${value}`);
  }
  return true;
}

export function validateRange(value, min, max, name = 'value') {
  validateNumber(value, name);
  if (value < min || value > max) {
    throw new Error(`${name} must be between ${min} and ${max}, got ${value}`);
  }
  return true;
}

export function validateFitted(isFitted, modelName = 'Model') {
  if (!isFitted) {
    throw new Error(`${modelName} must be fitted before making predictions. Call fit() first.`);
  }
  return true;
}
